import { createFileRoute } from '@tanstack/react-router';
import { Button, Container, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import { useCallback, MouseEventHandler } from 'react';
import { useSuspenseQuery } from '@apollo/client';
import { myBrandsDocument } from '@social-garden/api/documents/brand.ts';
import useBrandUsage from '@/hooks/useBrandUsage.ts';
import PageTitle from '@/components/PageTitle.tsx';
import BrandListItem from '@/components/BrandListItem.tsx';
import ButtonLink from '@/components/ButtonLink.tsx';

export const Route = createFileRoute('/_manager/_app/brands/')({
  component: Brands,
});

function Brands() {
  const { t } = useTranslation(['common', 'manager']);
  const {
    data: { myBrands },
  } = useSuspenseQuery(myBrandsDocument);
  const navigate = useNavigate();
  const { exceeded } = useBrandUsage();

  const handleOnBrandEditClick = useCallback<
    MouseEventHandler<HTMLButtonElement>
  >(
    async (event) => {
      await navigate({
        to: '/brands/$id/update',
        params: {
          id: event.currentTarget.value,
        },
      });
    },
    [navigate],
  );

  return (
    <Container>
      <Grid container spacing={4}>
        <Grid container size={12} alignItems="center">
          <Grid
            size={{
              xs: 12,
              md: 'grow',
            }}>
            <PageTitle>{t('manager:navigation.brands')}</PageTitle>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 'auto',
            }}>
            <ButtonLink
              variant="contained"
              size="large"
              disabled={exceeded}
              to="/brands/create">
              {t('manager:brand.create.newButton')}
            </ButtonLink>
          </Grid>
        </Grid>
        {myBrands.map((brand) => (
          <Grid
            key={brand.id}
            size={{
              xs: 12,
              sm: 6,
              md: 4,
              lg: 3,
            }}>
            <BrandListItem brand={brand}>
              <Button value={brand.id} onClick={handleOnBrandEditClick}>
                {t('common:edit')}
              </Button>
            </BrandListItem>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
